export const INITIALISE_CAROUSEL = 'BEAMLY/CCX/INITIALISE_CAROUSEL';
export const SET_INDEX_CAROUSEL = 'BEAMLY/CCX/SET_INDEX_CAROUSEL';
export const SET_TRANSITION_START_CAROUSEL = 'BEAMLY/CCX/SET_TRANSITION_START_CAROUSEL';
export const SET_TRANSITION_END_CAROUSEL = 'BEAMLY/CCX/SET_TRANSITION_END_CAROUSEL';
export const SET_NO_OF_PAGES_CAROUSEL = 'BEAMLY/CCX/SET_NO_OF_PAGES_CAROUSEL';

export const initialise = ({
  carouselsStoreDataKey,
  noOfItems,
  noPerPage,
  infinite,
}) => ({
  type: INITIALISE_CAROUSEL,
  carouselsStoreDataKey,
  noOfItems,
  noPerPage,
  infinite,
});

export const setIndex = ({ carouselsStoreDataKey, index }) => ({
  type: SET_INDEX_CAROUSEL,
  carouselsStoreDataKey,
  index,
});

export const setTransitionStart = ({ carouselsStoreDataKey }) => ({
  type: SET_TRANSITION_START_CAROUSEL,
  carouselsStoreDataKey,
});

export const setTransitionEnd = ({ carouselsStoreDataKey }) => ({
  type: SET_TRANSITION_END_CAROUSEL,
  carouselsStoreDataKey,
});

export const setNoOfPages = ({ carouselsStoreDataKey, noOfItems, noPerPage }) => ({
  type: SET_NO_OF_PAGES_CAROUSEL,
  carouselsStoreDataKey,
  noOfItems,
  noPerPage,
});
